import React, {Component} from 'react';
import IntlCurrencyInput from "react-intl-currency-input";

const currencyConfig = {
    locale: 'pt-BR', formats: {
        number: {
            BRL: {
                style: 'currency', currency: 'BRL', minimumFractionDigits: 2, maximumFractionDigits: 2,
            },
        },
    },
};

const tableStyles = {
    wrapper: {
        marginBottom: '24px',
    },
    label: {
        fontFamily: "'Archivo Expanded', 'Archivo', sans-serif",
        fontWeight: 400,
        fontSize: '19px',
        color: '#5B595B',
        marginBottom: '12px',
        display: 'block',
    },
    table: {
        width: 'auto',
        borderCollapse: 'collapse',
        border: 'none',
    },
    th: {
        fontFamily: "'Archivo Expanded', 'Archivo', sans-serif",
        fontWeight: 700,
        fontSize: '23px',
        color: '#5B595B',
        textAlign: 'center',
        padding: '10px 24px',
        border: 'none',
        backgroundColor: 'transparent',
    },
    tdEven: {
        fontFamily: "'Archivo Expanded', 'Archivo', sans-serif",
        fontWeight: 400,
        fontSize: '19px',
        color: '#5B595B',
        textAlign: 'center',
        padding: '8px 24px',
        border: '1px solid #BCBEC0',
        backgroundColor: '#FFFFFF',
    },
    tdOdd: {
        fontFamily: "'Archivo Expanded', 'Archivo', sans-serif",
        fontWeight: 400,
        fontSize: '19px',
        color: '#5B595B',
        textAlign: 'center',
        padding: '8px 24px',
        border: '1px solid #BCBEC0',
        backgroundColor: '#EEEFF0',
    },
    input: {
        border: '1px solid #4D5A31',
        borderRadius: 0,
        fontFamily: "'Archivo Expanded', 'Archivo', sans-serif",
        fontWeight: 400,
        fontSize: '19px',
        color: '#5B595B',
        padding: '4px 8px',
        width: '100%',
        outline: 'none',
        backgroundColor: '#FFFFFF',
        boxSizing: 'border-box',
    },
};

class EstoqueValoresForm extends Component {

    render() {
        const showValor = this.props.observacao === 'Valor incorreto';
        const showEstoque = this.props.observacao === 'Estoque incorreto';

        const labelText = showValor
            ? 'Informe o valor do empreendimento'
            : 'Informe o estoque do empreendimento';

        const filteredTipologias = this.props.state.tipologias.filter(t => {
            const tipo = (t.type_of_typology || '').toLowerCase();
            return tipo !== 'venda' && tipo !== 'distrato' && tipo !== 'distratos';
        });

        if (filteredTipologias.length === 0) return null;

        return (
            <div style={tableStyles.wrapper}>
                <style>{`
                    .chamados-estoque-input::placeholder {
                        font-family: 'Archivo', sans-serif;
                        font-style: italic;
                        font-weight: 400;
                        font-size: 20px;
                        color: #B3B3B3;
                    }
                `}</style>
                <span style={tableStyles.label}>{labelText}</span>
                <table style={tableStyles.table}>
                    <thead>
                        <tr>
                            <th style={tableStyles.th}>Área Privativa</th>
                            <th style={tableStyles.th}>Tipologia</th>
                            <th style={tableStyles.th}>Dormitórios</th>
                            <th style={tableStyles.th}>Unidades</th>
                            {showValor  && <th style={tableStyles.th}>Valor</th>}
                            {showEstoque && <th style={tableStyles.th}>Estoque</th>}
                        </tr>
                    </thead>
                    <tbody>
                        {filteredTipologias.map((tipologia, index) => {

                            if (tipologia.estoque === undefined) tipologia.estoque = null;
                            if (tipologia.valor   === undefined) tipologia.valor   = null;

                            const tdStyle = index % 2 === 0 ? tableStyles.tdOdd : tableStyles.tdEven;

                            return (
                                <tr key={tipologia.id}>
                                    <td style={tdStyle}>{tipologia.private_area}</td>
                                    <td style={tdStyle}>{tipologia.type_of_typology}</td>
                                    <td style={tdStyle}>{tipologia.number_bedroom}</td>
                                    <td style={tdStyle}>{tipologia.qty}</td>
                                    {showValor && (
                                        <td style={tdStyle}>
                                            <IntlCurrencyInput
                                                currency="BRL"
                                                config={currencyConfig}
                                                value={tipologia.valor}
                                                onChange={(event, value, maskedValue) => {
                                                    let tipologias = [...this.props.state.tipologias];
                                                    tipologias[this.props.state.tipologias.indexOf(tipologia)].valor = maskedValue;
                                                    this.props.updateTipologias(tipologias);
                                                }}
                                                className="chamados-estoque-input"
                                                style={tableStyles.input}
                                                placeholder="Digite"
                                            />
                                            {this.props.state.errors[`${index}.valor`] && (
                                                <div className="invalid-feedback" style={{display: 'block'}}>
                                                    {this.props.state.errors[`${index}.valor`]}
                                                </div>
                                            )}
                                        </td>
                                    )}
                                    {showEstoque && (
                                        <td style={tdStyle}>
                                            <input
                                                type="text"
                                                inputMode="numeric"
                                                className="chamados-estoque-input"
                                                style={tableStyles.input}
                                                value={tipologia.estoque ?? ''}
                                                placeholder="Digite"
                                                onChange={(e) => {
                                                    const onlyNums = e.target.value.replace(/[^0-9]/g, '');
                                                    let tipologias = [...this.props.state.tipologias];
                                                    tipologias[this.props.state.tipologias.indexOf(tipologia)].estoque = onlyNums;
                                                    this.props.updateTipologias(tipologias);
                                                }}
                                            />
                                            {this.props.state.errors[`${index}.estoque`] && (
                                                <div className="invalid-feedback" style={{display: 'block'}}>
                                                    {this.props.state.errors[`${index}.estoque`]}
                                                </div>
                                            )}
                                        </td>
                                    )}
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </div>
        );
    }

}

export default EstoqueValoresForm;
